export default function levelReducer(state = {
  levels: [],
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_LEVEL_LIST_PENDING':
    case 'GET_LEVEL_PENDING': {
      return {...state, fetching: true, fetched: false};
    }
    case 'GET_LEVEL_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        levels: action.payLoad.data,
      };
    }
    case 'GET_LEVEL_LIST_REJECTED':
    case 'GET_LEVEL_REJECTED': {
      return {...state, error: action.payLoad};
    }
    case 'GET_LEVEL_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        level: action.payLoad.data,
      };
    }
    case 'DELETE_LEVEL_FULFILLED': {
      const newState = {...state};
      newState.levels = newState.levels.filter(level => level.id !== action.payLoad);
      return newState;
    }
    default: return {...state};
  }
}



// WEBPACK FOOTER //
// ./src/reducers/levelReducer.js